import { createAction, props } from '@ngrx/store';
import { Config, ConfigEditorDetailVariant } from '../../domain/config';

const feature = '[CXB General Config editor Screen]';

export const loadCxbGeneralConfigEntries = createAction(`${feature} Load general config entries`);
export const loadCxbGeneralConfigEntriesSuccess = createAction(
  `${feature} Load general config entries success`,
  props<{ configs: Config[] }>()
);
export const loadCxbGeneralConfigEntriesFail = createAction(
  `${feature} Load general config entries fail`,
  props<{ errorMessage: string }>()
);

export const loadCxbGeneralConfigEntry = createAction(`${feature} Load general config entry`, props<{ key: string }>());
export const loadCxbGeneralConfigEntrySuccess = createAction(
  `${feature} Load general config entry success`,
  props<{ config: Config; variant: ConfigEditorDetailVariant }>()
);
export const loadCxbGeneralConfigEntryFail = createAction(`${feature} Load general config entry fail`, props<{ errorMessage: string }>());

export const leaveConfigEditorDetailScreen = createAction(`${feature} Leave general config editor detail screen`);

export const createCxbGeneralConfigEntry = createAction(`${feature} Create general config entry`, props<{ config: Config }>());
export const createCxbGeneralConfigEntrySuccess = createAction(`${feature} Create general config entry success`, props<{ key: string }>());
export const createCxbGeneralConfigEntryFail = createAction(
  `${feature} Create general config entry fail`,
  props<{ errorMessage: string }>()
);

export const updateCxbGeneralConfigEntry = createAction(`${feature} Update general config entry`, props<{ config: Config }>());
export const updateCxbGeneralConfigEntrySuccess = createAction(`${feature} Update general config entry success`, props<{ key: string }>());
export const updateCxbGeneralConfigEntryFail = createAction(
  `${feature} Update general config entry fail`,
  props<{ errorMessage: string }>()
);

export const deleteCxbGeneralConfigEntry = createAction(`${feature} Delete general config entry`, props<{ key: string }>());
export const deleteCxbGeneralConfigEntrySuccess = createAction(`${feature} Delete general config entry success`, props<{ key: string }>());
export const deleteCxbGeneralConfigEntryFail = createAction(
  `${feature} Delete general config entry fail`,
  props<{ errorMessage: string }>()
);
